import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
/** All materials the staff member can browse (to assign to a class). */
export function useAllMaterials() {
    return useQuery({
        queryKey: ['staff-materials'],
        queryFn: () => apiClient('/materials'),
        staleTime: 1000 * 60 * 5,
    });
}
/** Materials currently assigned to a class. */
export function useClassMaterials(classId) {
    return useQuery({
        queryKey: ['class-materials', classId],
        queryFn: () => apiClient(`/materials/class/${classId}`),
        enabled: !!classId,
        staleTime: 1000 * 30,
    });
}
export function useAssignClassMaterial(classId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (materialId) => apiClient(`/materials/class/${classId}/assign`, {
            method: 'POST',
            body: JSON.stringify({ material_id: materialId }),
        }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['class-materials', classId] }),
    });
}
export function useRemoveClassMaterial(classId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (materialId) => apiClient(`/materials/class/${classId}/${materialId}`, { method: 'DELETE' }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['class-materials', classId] }),
    });
}
/** A class's free-text description ("lo dado en clase"). */
export function useClassDescription(classId) {
    return useQuery({
        queryKey: ['class-description', classId],
        queryFn: () => apiClient(`/attendance/class/${classId}/description`),
        enabled: !!classId,
        staleTime: 1000 * 30,
    });
}
export function useSetClassDescription(classId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (description) => apiClient(`/attendance/class/${classId}/description`, {
            method: 'PATCH',
            body: JSON.stringify({ description }),
        }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['class-description', classId] }),
    });
}
//# sourceMappingURL=useClassMaterials.js.map